module.exports = __webpack_public_path__ + "img/2.62f0eb18.jpg";